export default "__VITE_ASSET__Cjr9BBW9__"